<template>
  <div class="video-container">
    <div class="video-box" :class="activated ?'activated':''">
      <div v-if="video.number" class="video-box-con">
        <iframe
          v-if="video.camera_type==1"
          :src="'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/'+video.number+'/'+video.channel+'.live&autoplay=1&accessToken='+ this.video.access_token"
          width="100%"
          height="100%"
          :id="'video'+video.number"
          allowfullscreen
        >
        </iframe>
        <iframe
          v-else-if="video.camera_type==2"
          :src="'../../../static/lcy_video/webLive.html?url='+video.number+'|kitToken='+video.access_token"
          width="100%"
          height="100%"
          :id="'video'+video.number"
          allowfullscreen
        >
        </iframe>
        <div v-else 
          class="video-in" 
          :id="'video'+video.number"
          >
        </div>
      </div>
      <div class="none">
        <div class="icon-box"><svg-icon name="camera"/></div>
        {{$t('camera.no_camera')}}
      </div>
    </div>
  </div>
</template>
<script>
import { QNRTPlayer } from "qn-rtplayer-web";
import { setTimeout } from "timers"
import cameraApi from "@/api/device/camera";
export default {
  props: {
    video: {
      type: Object,
      required: true,
      default: function () {
        return {
          number: '',
          camera_type: 1,
          channel: 1,
          access_token: ''
        }
      }
    },
    activated: {
      type: Boolean,
      default: function (e) {
        return false
      }
    }
  },
  data() {
    return {
      player: null
    }
  },
  watch: {
    video: {
      handler(newVal) {
        if(newVal){
          if(newVal.number){
            if(newVal.camera_type==3) {
              this.qnyPlayerinit()
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  destroyed() {
    if(this.video.camera_type==3) { 
      this.player = null
      this.qnyStopFlow()
    }
  },
  methods: {
    async qnyPlayerinit() {
      this.player = new QNRTPlayer();
      this.player.init({
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      });
      setTimeout(() => {
        this.streamUrl()
      }, 500);
    },
    async streamUrl() {
      await cameraApi.qnyGetStreamUrl(this.video.number).then((res) => {
        // console.log('streamUrl', res.data.data.playUrls.rtmp)
        if (res.data.code == 1000) {
          this.qnyStartFlow(res.data.data.playUrls.webrtc)
        }
      });
    },
    async qnyStartFlow(url) {
      await cameraApi.qnyFlow(this.video.number, {
        type: 1
      }).then((res) => {
        if (res.data.code === 1000) {
          this.player.play(
            url,
            document.getElementById('video'+this.video.number)
          )
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    qnyStopFlow() {
      cameraApi.qnyFlow(this.video.number, {
        type: 0
      }).then((res) => {
      });
    }
  }
}
</script>
<style lang='less' scoped> 
.video-container{
  width: 100%;
  height: 100%;
  background: #1c2029;
  border: 4px solid #000;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  float: left;
  .video-box{
    width: 100%;
    height: 100%;
    position: relative;
    border: 3px solid #1c2029;
    box-sizing: border-box;
    .video-box-con{
      width: 100%;
      height: 100%;
      position: relative;
    }
    &.activated {
      border:2px solid #0c82fe;
    }
    iframe,.video-in{
      width:100%;
      height:100%;
      padding:0;
      border:0;
      margin:0;
      position: relative;
      pointer-events: none;
    }

    .none{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      color:#4e5a6a;
      .icon-box{
        font-size: 62px;
      }
    }
  }
  
}
</style>
